import { easings, useSpring, useTransition } from '@react-spring/web';

const useAnimations = (isOpen: boolean) => {
  const { easeInSine } = easings;

  const filterDrawerAnimationDesktop = useSpring({
    from: {
      width: 0,
    },
    to: {
      width: isOpen ? 434 : 0,
    },
    config: {
      duration: 200,
      easing: easeInSine,
    },
  });

  const filterDrawerAnimationMobile = useSpring({
    from: {},
    to: {
      transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
    },
    config: {
      duration: 350,
      easing: easeInSine,
    },
  });

  const blackBackgroundAnimation = useTransition(isOpen, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 1600, friction: 300 },
  });

  const filterCTAAnimationLeft = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isOpen ? 1 : 0,
      transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
    },
    config: {
      duration: 200,
      easing: easeInSine,
    },
  });

  const filterCTAAnimationRight = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isOpen ? 1 : 0,
      transform: isOpen ? 'translateX(0%)' : 'translateX(100%)',
    },
    config: {
      duration: 250,
      easing: easeInSine,
    },
  });

  const showFiltersDesktopAnimation = useSpring({
    from: {
      left: '-100px',
    },
    to: {
      left: '0',
    },
    delay: 50,
    config: {
      duration: 100,
      easing: easeInSine,
    },
  });

  const showFiltersAdditionaAnimation = useSpring({
    from: {
      height: '100px',
    },
    to: {
      height: '50px',
    },
    delay: 2000,
    config: {
      duration: 200,
      easing: easeInSine,
    },
  });

  const textOpacityAnimation = useSpring({
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
    delay: 1950,
    config: {
      duration: 100,
      easing: easeInSine,
    },
  });

  const textAppearenceAnimation = useSpring({
    from: {
      display: 'auto',
    },
    to: {
      display: 'none',
    },
    delay: 2000,
    config: {
      duration: 150,
      easing: easeInSine,
    },
  });

  const dropdownAnimation = useTransition(isOpen, {
    from: { maxHeight: 0 },
    enter: { maxHeight: 2000 },
    leave: { maxHeight: 0 },
    config: { tension: 1600, friction: 200 },
  });

  const filtersAccordianAnimation = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isOpen ? 1 : 0,
    },
    config: {
      duration: 150,
      easing: easeInSine,
    },
  });

  const backgroundAnimation = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isOpen ? 0.7 : 0,
    },
    config: {
      easing: easeInSine,
    },
    delay: 250,
  });

  const rightShadowAppearance = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: !isOpen ? 1 : 0,
    },
    config: {
      easing: easeInSine,
    },
    // delay: 250,
  });

  const leftShadowAppearance = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: !isOpen ? 1 : 0,
    },
    config: {
      easing: easeInSine,
    },
    // delay: 250,
  });

  return {
    filterDrawerAnimationDesktop,
    filterDrawerAnimationMobile,
    blackBackgroundAnimation,
    filterCTAAnimationLeft,
    filterCTAAnimationRight,
    showFiltersDesktopAnimation,
    showFiltersAdditionaAnimation,
    textOpacityAnimation,
    textAppearenceAnimation,
    filtersAccordianAnimation,
    dropdownAnimation,
    rightShadowAppearance,
    leftShadowAppearance,
  };
};

export default useAnimations;
